import { mmFetchWithResponse } from './mmFetchWithResponse';

const qualityApi = {
    getCCOF: async (facilityID) => {
        const url = `api/quality/v1/ccof?facilityID=${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getDirectedRecPhase3Enabled: async (facilityID) => {
        const url = `api/quality/v3/receiving/phase3Enabled/${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getPendingIssues: async (facilityID) => {
        const url = `api/quality/v3/receiving/pendingIssues/${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    didNotArrive: async (poMapID) =>
        mmFetchWithResponse(`api/quality/v3/receiving/didNotArrive/${poMapID}`, {
            method: 'POST',
        }),
    recordCasesCounted: async (poMapID, casesCounted) => {
        const uri = `api/quality/v3/receiving/record/${poMapID}/casesCounted`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                casesCounted,
            }),
        });
    },
    recordCaseUnitCountValue: async (poMapID, caseIdx, value) => {
        const uri = `api/quality/v3/receiving/record/${poMapID}/caseUnitCount`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                value,
                caseIdx,
            }),
        });
    },
    resetQCModule: async (purchaseOrderMapId, moduleName) => {
        const uri = `api/quality/v1/receiving/items/${purchaseOrderMapId}/modules/${moduleName}/desktop-reset`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
        });
    },

    getQualityControlTasks: async (type, facilityID) => {
        const url = `api/inventory/v1/task/qc?type=${type}&facilityID=${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getQualityIssueCodes: async () => {
        const url = `api/quality/v2/receiving/issueCodes`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    recordPalletsInspected: async (poMapID, palletsInspected, issueLevel) => {
        const uri = `api/quality/v2/receiving/record/palletsInspected/${poMapID}`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                palletsInspected,
                issueLevel,
            }),
        });
    },
    recordCasesInspected: async (poMapID, casesInspected, issueLevel) => {
        const uri = `api/quality/v2/receiving/record/casesInspected/${poMapID}`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                casesInspected,
                issueLevel,
            }),
        });
    },
    recordQualityUnitInspection: async (poMapID, sendParams) => {
        const uri = `api/quality/v3/receiving/unitInspection/${poMapID}`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    recordQualityReceiving: async (poMapID, sendParams) => {
        const url = `api/quality/v1/receiving/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    getQualityPODetailsV2: async (poID, isPackaging) => {
        const url = `api/quality/v2/receiving?poID=${poID}&isPackaging=${isPackaging}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    recordQualityReceivingIssueV2: async (qcrExternalIssueID, sendParams, poMapID, issueLevel) => {
        const url = `api/quality/v2/receiving/issue/${poMapID}/${qcrExternalIssueID}`;
        const params = { ...sendParams, issueLevel };
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(params),
        });
    },
};

export { qualityApi };
